import React from "react";
import { navigate } from "gatsby";
import {
  productContainer, image, content,
  productTitle, description, priceContainer,
  contentBottom, price, plus,
  addToCart, prices, added, outOfStock, outOfStockInfo
} from "components/cross-sell-pdp/style.mod.scss";
import Money from "components/money";
import { PlusLg, CheckLg } from "react-bootstrap-icons";
import storeCurrency from "helpers/currency";
import getImagePath from "helpers/get-image-path";
import locales from "locales";

const SecondaryCrossSellStyle = ({
  addVariantToCart,
  selectedVariant,
  addVariant,
  type,
  variantIsAdded,
  differencePrice,
  productLink
}) => {
  const handleAddVariant = () => {
    if (selectedVariant?.variant?.store?.inStock) {
      (type === "eco-package" ? addVariant : addVariantToCart)(selectedVariant?.variant);
    } else {
      return;
    }
  };
  return (
    selectedVariant?.variant?.store && 
    <div className={`${productContainer} ${selectedVariant?.variant?.store?.inStock ? "" : outOfStock}`}
    >
      <div className={image} onClick={() => navigate(productLink)}>
        <img
          src={getImagePath(selectedVariant?.image)}
          alt={selectedVariant?.image?.alt}
        />
      </div>
      <div className={content}>
        <div className={productTitle} onClick={() => navigate(productLink)}>
          <span>{selectedVariant?.title}</span>
        </div>
        <p className={description} onClick={() => navigate(productLink)}>{selectedVariant?.description}</p>
        <div className={contentBottom}>
          <div className={priceContainer} onClick={() => navigate(productLink)}>
            <div className={prices}>
              <span className={price}>
                <span className={plus}>+</span>
                {selectedVariant?.variant?.store?.price !== 0 ? (
                  type === "eco-package" ? <Money value={differencePrice} integer={true} /> : <Money value={type ? differencePrice : selectedVariant?.variant?.store?.price} integer={true} />
                ) : (
                  <>0{storeCurrency()}</>
                )}
              </span>
            </div>
          </div>
          <span className={`${addToCart} ${variantIsAdded ? added : ""}`} onClick={handleAddVariant}>
            {variantIsAdded ? <CheckLg /> : <PlusLg />}
          </span>
        </div>
        {!selectedVariant?.variant?.store?.inStock &&
          <p className={outOfStockInfo}>
            {locales.products.outOfStock}
          </p>
        }
      </div>
    </div>
  );
};


export default SecondaryCrossSellStyle;